import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';

import {
  createContentEntityMultilingualAsync,
  getContentEntityTypeLookupsAsync,
  editContentEntityMultilingualAsync,
  getContentEntityTypeByIdMultilingualAsync,
  getContentEntityTypesDatatableAsync,
} from './slices';
import { Server } from '@wajeez-web/core/api-base';

export const getContentEntityTypesLookups = async (
  data: void,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityTypeLookupsAsync());

  return handleDispatchResult(res, onSuccess);
};

export const createContentEntityTypeMultilingual = async (
  data: Server.CreateContentEntityTypeV2Input,
  onSuccess?: (contentEntityId: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createContentEntityMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editContentEntityTypeMultilingual = async (
  data: Server.UpdateContentEntityTypeInput,
  onSuccess?: (contentEntityId: number) => void | Promise<void>
) => {
  const res = await store.dispatch(editContentEntityMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityTypeByIdMultilingual = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getContentEntityTypeByIdMultilingualAsync(id)
  );

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityTypesDatatable = async (
  data: Server.ContentEntityTypeDatatable,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityTypesDatatableAsync(data));

  return handleDispatchResult(res, onSuccess);
};
